import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/familyMemberResource";
import RHFSelect from "components/forms/RHFSelect";

export default function FamilyMemberForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={4}>
                <RHFSelect
                    name={resource.fields.relation.name}
                    control={control}
                    label={resource.fields.relation.label}
                    required={resource.fields.relation.required}
                    options={resource.fields.relation.options ?? []}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.firstName.label}
                    required={resource.fields.firstName.required}
                    {...register(resource.fields.firstName.name)}
                    error={!!errors.firstName}
                    helperText={errors.firstName?.message}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.middleName.label}
                    {...register(resource.fields.middleName.name)}
                    error={!!errors.middleName}
                    helperText={errors.middleName?.message}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.lastName.label}
                    required={resource.fields.lastName.required}
                    {...register(resource.fields.lastName.name)}
                    error={!!errors.lastName}
                    helperText={errors.lastName?.message}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <RHFSelect
                    name={resource.fields.suffix.name}
                    control={control}
                    label={resource.fields.suffix.label}
                    options={resource.fields.suffix.options ?? []}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.dateOfBirth.label}
                    type={resource.fields.dateOfBirth.type}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.dateOfBirth.name)}
                    error={!!errors.dateOfBirth}
                    helperText={errors.dateOfBirth?.message}
                />
            </GridItem>

            <GridItem xs={12}>
                <DTextField
                    label={resource.fields.birthPlace.label}
                    {...register(resource.fields.birthPlace.name)}
                    error={!!errors.birthPlace}
                    helperText={errors.birthPlace?.message}
                />
            </GridItem>

            <GridItem xs={12} md={6}>
                <DTextField
                    label={resource.fields.occupation.label}
                    {...register(resource.fields.occupation.name)}
                    error={!!errors.occupation}
                    helperText={errors.occupation?.message}
                />
            </GridItem>

            <GridItem xs={12} md={6}>
                <DTextField
                    label={resource.fields.employer.label}
                    {...register(resource.fields.employer.name)}
                    error={!!errors.employer}
                    helperText={errors.employer?.message}
                />
            </GridItem>

            <GridItem xs={12}>
                <DTextField
                    label={resource.fields.maidenName.label}
                    {...register(resource.fields.maidenName.name)}
                    error={!!errors.maidenName}
                    helperText={errors.maidenName?.message}
                />
            </GridItem>

            <GridItem xs={12} md={8}>
                <DTextField
                    label={resource.fields.phoneNumber.label}
                    {...register(resource.fields.phoneNumber.name)}
                    error={!!errors.phoneNumber}
                    helperText={errors.phoneNumber?.message}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.phoneNumberExt.label}
                    {...register(resource.fields.phoneNumberExt.name)}
                    error={!!errors.phoneNumberExt}
                    helperText={errors.phoneNumberExt?.message}
                />
            </GridItem>

            <GridItem xs={12}>
                <DTextField
                    label={resource.fields.adress1.label}
                    multiline
                    minRows={2}
                    {...register(resource.fields.adress1.name)}
                    error={!!errors.adress1}
                    helperText={errors.adress1?.message}
                />
            </GridItem>

            <GridItem xs={12}>
                <DTextField
                    label={resource.fields.adress2.label}
                    multiline
                    minRows={2}
                    {...register(resource.fields.adress2.name)}
                    error={!!errors.adress2}
                    helperText={errors.adress2?.message}
                />
            </GridItem>

            <GridItem xs={12}>
                <DTextField
                    label={resource.fields.adress3.label}
                    multiline
                    minRows={2}
                    {...register(resource.fields.adress3.name)}
                    error={!!errors.adress3}
                    helperText={errors.adress3?.message}
                />
            </GridItem>
        </GridContainer>
    );
}
